import { useTranslations } from 'next-intl'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { Tag } from '@/components/elementary/Tag'
import Heading from '@/components/typography/Heading'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'
import type { GridCardProps } from '@/types/general'
import type { ServerRenderedEntry } from '@/types/helpers'
import styles from './IntegrationsCard.module.css'
import { TileIcon } from './shared/TileIcon'

export function IntegrationsCard({
	icon,
	title,
	author,
	description,
	tag,
	serverProcessedHtmlDescription,
	serverProcessedHtmlContent,
}: ServerRenderedEntry<GridCardProps>) {
	const t = useTranslations('IntegrationsCard')
	return (
		<div className="p-4 md:p-6 w-full">
			<div className="flex flex-col items-start gap-4">
				<div className="flex flex-row items-start gap-4">
					{icon && <TileIcon icon={icon} size="medium" />}
					<div className="flex flex-col items-start text-left">
						{title && (
							<Heading tag="h3" className={cn('text-left', styles['integrations-card-title'])}>
								{title}
							</Heading>
						)}
						<div className="flex flex-col w-full items-start text-left">
							{author && (
								<Paragraph fontSize="bodyRegularSmall">
									{t('by')} {author}
								</Paragraph>
							)}

							{serverProcessedHtmlDescription ? (
								<div className="mt-4 text-brand-black text-left block md:hidden">
									{serverProcessedHtmlDescription}
								</div>
							) : (
								<div className="mt-4 text-brand-black text-left block md:hidden">
									<CkEditorCSRRenderer
										defaultTypography="bodyMedium"
										variant="textOnly"
										htmlContent={description}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
			{serverProcessedHtmlContent ? (
				<div className="mt-4 text-brand-black text-left hidden md:block">
					{serverProcessedHtmlContent}
				</div>
			) : (
				<div className="mt-4 text-brand-black text-left hidden md:block">
					<CkEditorCSRRenderer
						defaultTypography="bodyMedium"
						variant="textOnly"
						htmlContent={description}
					/>
				</div>
			)}
			{tag && (
				<Tag
					name={tag.name}
					variant={tag.variant?.variant}
					size="small"
					customColors={
						tag.customColors
							? {
									backgroundColor: tag.customColors.backgroundColor?.color,
									textColor: tag.customColors.textColor?.color,
									borderColor: tag.customColors.borderColor?.color,
								}
							: undefined
					}
					className="w-fit mt-3"
				/>
			)}
		</div>
	)
}
